module.exports = __webpack_public_path__ + "static/media/pentagram_inside_outside.5c9db8bb.png";